import React from "react";
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
// if you're in create-react-app import the files as:
import App from "./App";
import * as serviceWorker from './serviceWorker';
import { createStore, applyMiddleware } from 'redux'
import configureStore from './js/store/index';
import thunk from 'redux-thunk'
import rootReducer from './js/reducers/rootReducer'
import { fetchAllAnnouncement } from './js/actions/index'
import { fetchAllMaps } from './js/actions/index'

const store = createStore(rootReducer, applyMiddleware(thunk));

store.dispatch(fetchAllMaps());
store.dispatch(fetchAllAnnouncement());


ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
